const { getListArgs } = require('../../../tools/sql-tools')

const locationTransactionListQuery = ({ locationIds, txnType, noLimit, overduePayment, startDate, endDate, limit, offset }) => {
  const values = [...locationIds]
  const { args: locationArg } = getListArgs(values)
  let whereClause = ''
  let limitCondition = ''

  if (txnType) {
    values.push(txnType)
    const { args } = getListArgs([txnType], values.length)
    whereClause = ` txn_type = ${args} `
  }
  if (overduePayment) {
    whereClause = txnType
      ? ` ${whereClause} AND tl.amount_paid < tl.amount AND now() >= tl.due_date`
      : ` tl.amount_paid < tl.amount AND now() >= tl.due_date `
  }
  if (startDate) {
    values.push(...[startDate])
    const { args } = getListArgs([startDate], values.length)
    whereClause = txnType || overduePayment
      ? ` ${whereClause} AND txn_date >= ${args} `
      : ` txn_date >= ${args} `
  }
  if (endDate) {
    values.push(...[endDate])
    const { args } = getListArgs([endDate], values.length)
    whereClause = txnType || overduePayment || startDate
      ? ` ${whereClause} AND txn_date < ${args}`
      : ` txn_date < ${args} `
  }

  if (!noLimit) {
    values.push(limit, offset)
    limitCondition = `LIMIT $${values.length - 1} OFFSET $${values.length}`
  }

  const query = `
    with location_base as (
      select
        uuid as location_id
      from avocado.data_location
      where uuid in (${locationArg})
    ),
    location_transactions as (
      select
        qt.transaction_uuid as id,
        qt.location_id,
        qt.company_code,
        qt.txn_id,
        qt.description,
        qt.code,
        qt.order_type,
        qt.created_at,
        qt.updated_at,
        qt.payment_plan_id,
        case
          when qt.txn_type = 'instalment' then 'installment'
          else qt.txn_type
        end as txn_type,
        qt.amount,
        qt.paid_amount,
        qt.due_date,
        qt.txn_date,
        qt.doc_number as quickbooks_doc_number,
        row_to_json(pp.*)::jsonb as payment_plan,
        case
          when qt.txn_type in ('invoice', 'instalment', 'refund') then 'debit' 
          else 'credit'
        end as posting_type
      from location_base lb
      cross join avocado.get_quickbookstransactions_by_location(lb.location_id) qt
      left join avocado.data_paymentplan pp on pp.id = qt.payment_plan_id::uuid
      where qt.company_code in ('NG', 'KE')
    ),
    quickbooks_transaction_lines as (
      select
        qt.*,
        bt.txn_type as base_txn_type,
        bt.payment_plan,
        bt.payment_plan_id
      from location_transactions bt
      inner join avocado.data_quickbookstransactions qt on qt.txn_id = bt.txn_id and qt.company_code = bt.company_code
      group by qt.id, bt.txn_type, bt.payment_plan, bt.payment_plan_id
    ),
    loan_transactions as (
      select
        qt.id,
        qt2.location_id,
        qt2.due_date,
        qt2.amount,
        qt.amount_paid,
        qt.description,
        'loan' as txn_type,
        qt.quickbooks_doc_number,
        qt2.txn_date,
        qt2.created_at,
        qt2.updated_at,
        qt2.order_type,
        qt.payment_plan,
        qt2.company_code,
        qt2.txn_id,
        'credit' as posting_type
      from quickbooks_transaction_lines qt
      inner join avocado.data_invoicepaymentplan ip on ip.qbo_txn_id = qt.txn_id and ip.qbo_company_code = qt.company_code
      left join avocado.data_quickbookstransactions qt2 on 
        qt2.txn_id = qt.payment_plan ->> 'quickbooks_journal_entry_id'
          and 
        qt2.company_code = qt.payment_plan ->> 'company_code'
      where qt.txn_type = 'invoice' and qt.base_txn_type = 'installment'
      group by 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    ),
    pending AS (
      select
        p.id,
        p.data ->> 'locationId' as "location_id",
        t.due_date,
        p.amount,
        null::float as amount_paid,
        concat('REM:R-', p."data" -> 'remitaResponse' -> 'body' ->> 'transactionRef') AS description,
        case
          when p.reference like 'P-%' then 'pending installment payment'
          else 'pending invoice payment'
        end as txn_type,
        p.reference as quickbooks_doc_number,
        p.updated_at::date as txn_date,
        p.created_at,
        p.updated_at,
        null as order_type,
        null::jsonb AS payment_plan,
        null as company_code,
        null as txn_id
      from location_base lb
      inner join avocado.data_paymentdebit p on
        p.data ->> 'locationId' = lb.location_id and
        p.data -> 'remitaResponse' -> 'body' ->> 'status' = 'Successful'
      left join location_transactions t on
        t.txn_type in ('payment', 'invoice', 'installment') and
        t.location_id = p.data ->> 'locationId' and (
          (string_to_array(t.description, '/'))[1] = concat('REM:R-', p."data" -> 'remitaResponse' -> 'body' ->> 'transactionRef')
        )
      WHERE t.id is null

      UNION

      SELECT
        p.id,
        p.location_id,
        due_date,
        -- The amount from paystack is in the currencies subunit, convert to main unit
        case when p.total_amount > 0 then p.total_amount
        else p.amount_in_cents / 100  end as amount,
        null::float as amount_paid,
        null AS description,
        'pending invoice payment' AS txn_type,
        quickbooks_doc_number,
        p.updated_at::date as txn_date,
        p.created_at,
        p.updated_at,
        null as order_type,
        null::jsonb AS payment_plan,
        null as company_code,
        null as txn_id
      FROM location_base lb
      inner join avocado.data_payment p on p.location_id = lb.location_id 
      LEFT JOIN location_transactions t
        ON t.txn_type = 'payment'
       AND t.description = "p"."payment_data" ->> 'reference'
       AND t.location_id = p.location_id
      WHERE (p.status = 'success' OR p.status = 'client_side_paid')
      and p.payment_method != 'credit' -- we need exclude credits from pending payments list
      and t.id IS NULL
      -- Payments made prior to the specified date should not be included in the pending payment logic.
      and p.created_at > '2023-06-08'

      UNION

      SELECT
        p.id,
        p.location_id,
        due_date,
        -- The amount from paystack is in the currencies subunit, convert to main unit
        p.amount_in_cents / 100 as amount,
        null::float as amount_paid,
        p.payment_data ->> 'reference' AS description,
        case 
          when p.qbo_txn_id is not null and p.qbo_company_code is not null then 'pending invoice payment'
          else 'pending installment payment'
        end as txn_type,
        quickbooks_doc_number,
        p.updated_at::date as txn_date,
        p.created_at,
        p.updated_at,
        null as order_type,
        null::jsonb AS payment_plan,
        p.qbo_company_code as company_code,
        p.qbo_txn_id as txn_id
      FROM location_base lb 
      inner join avocado.data_paygcreditpayment p on p.location_id = lb.location_id
      left join location_transactions t on
        t.txn_type = 'payment' and
        t.company_code = p.qbo_company_code and
        t.description = p.payment_data ->> 'reference'
      WHERE t.id is null
    ),
      transactions as (
        select 
          p.id,
          p.location_id,
          p.due_date,
          p.amount,
          p.amount_paid,
          p.description,
          p.txn_type,
          p.quickbooks_doc_number,
          p.txn_date,
          p.created_at,
          p.updated_at,
          p.order_type,
          p.payment_plan,
          'pending-credit' as posting_type,
          null as code,
          null as txn_id,
          null as company_code
        from pending p

        union 

        select
          lt.id,
          lt.location_id,
          lt.due_date,
          lt.amount,
          lt.amount_paid,
          lt.description,
          lt.txn_type,
          lt.quickbooks_doc_number,
          lt.txn_date,
          lt.created_at,
          lt.updated_at,
          lt.order_type,
          lt.payment_plan,
          lt.posting_type,
          null as code,
          lt.txn_id,
          lt.company_code
        from loan_transactions lt

        union

        SELECT
          tl.id,
          tl.location_id,
          tl.due_date,
          abs(tl.amount) as amount,
          tl.paid_amount as amount_paid,
          tl.description,
          tl.txn_type,
          tl.quickbooks_doc_number,
          tl.txn_date,
          tl.created_at,
          tl.updated_at,
          tl.order_type,
          tl.payment_plan,
          tl.posting_type,
          tl.code,
          tl.txn_id,
          tl.company_code
        from location_transactions tl
      )
      select
        t.id,
        t.location_id,
        t.due_date,
        t.amount,
        t.amount_paid,
        t.description,
        t.txn_type,
        t.quickbooks_doc_number,
        t.txn_date,
        t.created_at,
        t.updated_at,
        t.order_type,
        t.payment_plan,
        t.posting_type,
        t.code,
        il.shipment_id,
        il.order_id
      from transactions t
      left join avocado.data_invoicepaymentplan ip on ip.paymentplan_id = (t.payment_plan ->> 'id')::uuid
      left join avocado.data_invoice_quickbooks iq on
        (iq.invoice_txn_id = t.txn_id and iq.company_code = t.company_code) or
        (iq.invoice_txn_id = ip.qbo_txn_id and iq.company_code = ip.qbo_company_code) or
        (iq.creditmemo_txn_id = t.txn_id and iq.company_code = t.company_code)
      left join lateral (
        select
          il.invoice_id,
          il.shipment_id,
          il.order_id
        from avocado.data_invoice_line il
        where il.invoice_id = iq.invoice_id and
         (il.shipment_id IS NOT NULL OR il.order_id IS NOT NULL)
        LIMIT 1
      ) il ON true
      ${whereClause.length ? ` WHERE ${whereClause}` : ''}
      ORDER BY txn_date DESC, due_date desc, txn_type ASC
      ${limitCondition}
    `
  return { query, values }
}

module.exports = { locationTransactionListQuery }
